module.exports = __webpack_public_path__ + "static/media/google_play.6a9acd21.png";